import actions from "@/store/modules/local/actions";
import mutations from "@/store/modules/local/mutations";
import state from "@/store/modules/local/state";

export default {
    actions,
    mutations,
    state
}